// extracted by mini-css-extract-plugin
export default {"edit_your_box":"vi","edit_box_title":"wi","subscription":"xi","byb":"yi","recommended_for_you_title":"zi","explore":"Ai","recommended":"Bi","go_back":"Ci","wrapper":"Ei","product_img":"Fi","info":"Gi","remove_btn":"Hi"};
    if(module.hot) {
      // 1714422952412
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  